"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FriendlyFileSize = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var friendlyFileSize = function friendlyFileSize(bytes) {
  if (!bytes) return '';
  var maxSize = Math.floor(Math.log(bytes) / Math.log(1024));
  var friendlySize = ['B', 'KB', 'MB', 'GB', 'TB'][maxSize];
  var maxSizeBytes = (bytes / Math.pow(1024, maxSize)).toFixed(2) * 1.0;
  return "".concat(maxSizeBytes, " ").concat(friendlySize);
};

var FriendlyFileSize = function FriendlyFileSize(props) {
  var bytes = props.bytes;
  var fileSize = friendlyFileSize(bytes);
  return /*#__PURE__*/_react.default.createElement("span", null, fileSize);
};

exports.FriendlyFileSize = FriendlyFileSize;
FriendlyFileSize.propTypes = {
  bytes: _propTypes.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/file_size/index.js
// module id = 754
// module chunks = 0 15 16 17 18